import React from 'react';
import { AppBar, Toolbar, IconButton, Box, Tooltip, Divider } from '@mui/material';
import MenuIcon from '@mui/icons-material/Menu';
import { useAuth } from '../../hooks/useAuth';
import LogoutIcon from '@mui/icons-material/LogoutOutlined';
import NotificationBell from '../notifications/NotificationBell';

const TopBar = ({ onDrawerToggle, width }) => {
    const { logout } = useAuth();

    return (
        <AppBar
            position="fixed"
            elevation={0}
            sx={{
                width: { xs: '100%', md: `calc(100% - ${width}px)` },
                ml: { xs: 0, md: `${width}px` },
                backgroundColor: '#ffffff',
                borderBottom: '1px solid #E2E8F0',
                transition: 'width 0.2s ease, margin-left 0.2s ease',
            }}
        >
            <Toolbar
                sx={{
                    minHeight: '56px !important',
                    px: { xs: 2, md: 3 },
                    justifyContent: 'flex-end',
                }}
            >
                {/* Left side - Mobile menu only */}
                <Box sx={{ display: { xs: 'flex', md: 'none' }, mr: 'auto' }}>
                    <IconButton
                        aria-label="open drawer"
                        edge="start"
                        onClick={onDrawerToggle}
                        sx={{
                            color: '#475569',
                            '&:hover': {
                                backgroundColor: '#F1F5F9',
                            },
                        }}
                    >
                        <MenuIcon />
                    </IconButton>
                </Box>

                {/* Right side - Actions */}
                <Box
                    sx={{
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1,
                    }}
                >
                    <NotificationBell />

                    <Divider orientation="vertical" flexItem sx={{ mx: 0.5, height: 24, alignSelf: 'center', borderColor: '#E2E8F0' }} />

                    <Tooltip title="Sign out" arrow>
                        <IconButton
                            onClick={logout}
                            size="small"
                            sx={{
                                color: '#64748B',
                                borderRadius: 1.5,
                                width: 36,
                                height: 36,
                                transition: 'all 0.15s ease',
                                '&:hover': {
                                    backgroundColor: '#FEE2E2',
                                    color: '#DC2626',
                                },
                            }}
                        >
                            <LogoutIcon sx={{ fontSize: 20 }} />
                        </IconButton>
                    </Tooltip>
                </Box>
            </Toolbar>
        </AppBar>
    );
};

export default TopBar;
